import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UserProfile = () => {
  // Sample data (list of arrays)
  const [data,setData] = useState([])

  const getData = async () => {
    const email = JSON.parse(localStorage.getItem('__data')).email;
    
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get-data?email=${email}`);
      setData(res.data.user); // Assuming you want to store user data in state
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }
  

  useEffect(()=>{
    getData()
  },[])

  return (
    <div className="max-w-screen-xl mx-auto p-8 bg-gradient-to-r from-[#f9f9f9] to-[#ffffff] shadow-lg rounded-xl mt-10">
      <h2 className="text-3xl font-semibold mb-6 text-center text-blue-600">User Profile</h2>
      <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
        <table className="w-full table-auto border-collapse border border-gray-200">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Full Name</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">ID Type</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Last 4 Digits of ID</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Address</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Email</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Service</th>
              <th className="border border-gray-300 px-6 py-3 text-left font-semibold">Created On</th>
            </tr>
          </thead>
          <tbody>
            {data.map((user) => (
              <tr key={user._id} className="hover:bg-blue-50 transition-all duration-300">
                <td className="border border-gray-300 px-6 py-4">{user.full_name}</td>
                <td className="border border-gray-300 px-6 py-4">{user.idType}</td>
                <td className="border border-gray-300 px-6 py-4">{user.idLast4}</td>
                <td className="border border-gray-300 px-6 py-4">{user.address}</td>
                <td className="border border-gray-300 px-6 py-4">{user.email}</td>
                <td className="border border-gray-300 px-6 py-4">{user.serviceId}</td>
                <td className="border border-gray-300 px-6 py-4">{new Date(user.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserProfile;
